import { AuthContext } from '@urbanx/agx.auth.client';
import { AgxTab } from '@urbanx/agx.ui-components2';
import { ContentLayout, PageLayout } from 'layout';
import { useContext } from 'react';
import { Outlet } from 'react-router-dom';
import usePartnersPage from './pages/usePartnersPage';

const ReportingPage = () => {
  const { userAccount } = useContext(AuthContext);
  const { tabOptions, onTabChange } = usePartnersPage();

  return (
    <PageLayout
      agentName={userAccount?.firstName || ''}
      primaryPageTitle="Reporting"
      currentPageTitle="Partners"
      header={<AgxTab options={tabOptions} onChange={onTabChange} />}
    >
      <ContentLayout>
        <Outlet />
      </ContentLayout>
    </PageLayout>
  );
};

export default ReportingPage;
